import { ActionIcon, Badge, Card, Grid, Group, Stack, Text, Title, Tooltip } from '@mantine/core';
import { IconArrowDownCircle, IconArrowUpCircle, IconInfoCircle, IconTrendingUp } from '@tabler/icons-react';

const ConversionRateCard = ({ tittle, value, previousValue, tooltip }) => {
  const indicator =
    previousValue !== value ? (
      previousValue > value ? (
        <IconArrowDownCircle size={14} style={{ color: 'var(--mantine-color-danger-5)' }} />
      ) : (
        <IconArrowUpCircle size={14} style={{ color: 'var(--mantine-color-success-5)' }} />
      )
    ) : null;

  const formatValue = (rate) => {
    const numRate = Number(rate) || 0;
    return `${(numRate * 100).toFixed(1)}%`;
  };

  return (
    <Grid.Col span={{ base: 12, md: 4 }}>
      <Card padding="md" radius="md" withBorder>
        <Stack gap="xs">
          <Badge
            size="lg"
            radius="sm"
            leftSection={<IconTrendingUp size={16} />}
            styles={{ label: { textTransform: 'none', fontWeight: 600 } }}
          >
            {tittle}
          </Badge>
          <Group gap="xs" align="center">
            <Title order={4}>{formatValue(value)}</Title>
            {indicator}
            {tooltip ? (
              <Tooltip label={tooltip} multiline w={260} withArrow position="top">
                <ActionIcon variant="subtle" color="gray" size="sm" aria-label={tooltip} style={{ cursor: 'help' }}>
                  <IconInfoCircle size={16} />
                </ActionIcon>
              </Tooltip>
            ) : null}
          </Group>
          <Text size="sm" c="dimmed" pt="xs" style={{ borderTop: '1px solid var(--mantine-color-primary-filled)' }}>
            Previous: {formatValue(previousValue)}
          </Text>
        </Stack>
      </Card>
    </Grid.Col>
  );
};

export default ConversionRateCard;
